import { render, staticRenderFns } from "./ViewUpdateDealer.vue?vue&type=template&id=5acf2519&scoped=true"
import script from "./ViewUpdateDealer.vue?vue&type=script&lang=js"
export * from "./ViewUpdateDealer.vue?vue&type=script&lang=js"
import style0 from "./ViewUpdateDealer.vue?vue&type=style&index=0&id=5acf2519&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5acf2519",
  null
  
)

export default component.exports